<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      icon="dashboard"
    ></vuse-section-definition>
    <v-container fluid class="">
      <h1>Hi {{ userName }}</h1>
    </v-container>
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import Util from "../../helpers/utility";

export default {
  computed: {
    userName() {
      return Util.gv(this.account, "data.user.email");
    },
    ...mapState({
      account: (state) => state.account,
    }),
  },
  created() {},
  methods: {
    ...mapActions("users", {
      getAllUsers: "getAll",
      deleteUser: "delete",
    }),
  },
  data() {
    return {
      info: null,
      page: "Home",
      visitors: [],
      breadcrumbs: [
        {
          text: "Home",
          disabled: true,
        },
      ],
      methods: {},
    };
  },
};
</script>